import { AitLocation, AitTablePosition } from "aic";

/**
 * Builds display text for annotation location context.
 *
 * @param location - Optional table location for the annotation
 * @returns Formatted location string (e.g., "at column-1" or "at body-rowgroup-2 row-3")
 */
export const getContextDisplayText = (location?: AitLocation): string => {
  if (!location) return "";

  switch (location.position) {
    case AitTablePosition.table:
      return "";

    case AitTablePosition.column:
      return `at column-${location.originalColumn + 1}`;

    case AitTablePosition.headerRow:
      return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1} row-${location.row + 1}`;

    case AitTablePosition.headerCell:
      return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1} row-${location.row + 1}`;

    case AitTablePosition.bodyRowGroup:
      return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1}`;

    case AitTablePosition.bodyRow:
      return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1} row-${location.row + 1}`;

    case AitTablePosition.bodyCell:
      return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1} row-${location.row + 1}`;

    default:
      return "";
  }
};
